export const MAX_TICKET_SUBJECT_LENGTH = 1000;
export const MAX_TICKET_MESSAGE_EVENT_LENGTH = 10000;
